import React from 'react';
import './BudgetSlider.css';

export const BudgetSlider = ({ value, onChange, min, max, step }) => {
  return (
    <div className="budget-slider-container">
      <input 
        type="range" 
        min={min} 
        max={max} 
        step={step} 
        value={value} 
        onChange={(e) => onChange(e.target.value)}
        className="budget-slider"
      />
      <div className="budget-label">₹{Number(value).toLocaleString('en-IN')}</div>
    </div>
  );
};